import React, { useRef } from "react";
import "../ICSProjectDirector.css";
import { motion, useInView } from "framer-motion";
import kapwa from "../images/fgn.jpeg";
import cloudImage from '../images/cloud-removebg-preview.png';

function Kapwa() {
  // Reference for the description section
  const descriptionRef = useRef(null);
  const isDescriptionInView = useInView(descriptionRef, { once: true }); // Triggers only once when scrolled into view

  return (
    <div className="kapwa">
      {/* Title Section */}
      <motion.div
        className="experience-title"
        initial={{ opacity: 0, y: -50 }} // Start hidden and moved up
        animate={{ opacity: 1, y: 0 }} // Fade in and move down
        transition={{ duration: 1.5, ease: "easeOut" }} // Smooth transition
      >
        <h1>Filipino Googler's Network</h1>
        <p>
          As a mentee, Jerome was mentored under software engineers from Google when developing projects. Alongside this,
          he also participated in code reviews under this position where he helped improve code cleanliness and functinality.
        </p>
        <div className="image-container">
          <img src={kapwa} alt="FGN" className="fgn-image-one" />
    
        </div>

      </motion.div>

      {/* Description Section (Scroll-Triggered Animation) */}
      <motion.div
        ref={descriptionRef} // Attach the ref for scroll detection
        className="description"
        initial={{ opacity: 0, y: 50 }} // Start hidden and moved down
        animate={isDescriptionInView ? { opacity: 1, y: 0 } : {}} // Animate only when in view
        transition={{ duration: 1.5, ease: "easeOut" }} // Smooth transition
      >
        
        <h1>
          Collaborations: Filipino Googler's Network
          Jerome worked alongside his mentors in performing code reviews and proposal reviews to assist groups with understand how to approach their projects.
        
          Alongside his time as a mentee, he was able to recieve guidance and improvements on his projects such as "AI Debater"
        </h1>
      </motion.div>
      <div className="clouds">
        <img src={cloudImage} alt="cloud" className="cloud cloud1" />
        
        <img src={cloudImage} alt="cloud" className="cloud cloud3" />
        <img src={cloudImage} alt="cloud" className="cloud cloud4" />
        <img src={cloudImage} alt="cloud" className="cloud cloud5" />
        
        <img src={cloudImage} alt="cloud" className="cloud cloud7" />
        <img src={cloudImage} alt="cloud" className="cloud cloud8" />
      </div>
    </div>
  );
}

export default Kapwa;
